import AutocompleteMultiSelect from 'components/AutocompleteMultiSelect/AutocompleteMultiSelect'

export default AutocompleteMultiSelect
